import { Link } from "react-router-dom";
import { AlertTriangle, ShieldAlert, MapPinOff, CalendarX, Info } from "lucide-react";

const VARIANTS = {
  emergency: {
    icon: AlertTriangle,
    tone: "border-red-200 bg-red-50/70 text-red-900",
    iconTone: "text-red-600",
    label: "Not a medical emergency line",
  },
  hipaa: {
    icon: ShieldAlert,
    tone: "border-amber-200 bg-amber-50/70 text-amber-900",
    iconTone: "text-amber-600",
    label: "HIPAA notice",
  },
  availability: {
    icon: MapPinOff,
    tone: "border-slate-200 bg-slate-50/80 text-slate-700",
    iconTone: "text-slate-500",
    label: "Availability disclosure",
  },
  noshow: {
    icon: CalendarX,
    tone: "border-teal-200 bg-teal-50/60 text-teal-900",
    iconTone: "text-teal-700",
    label: "Cancellation policy",
  },
  info: {
    icon: Info,
    tone: "border-slate-200 bg-white text-slate-700",
    iconTone: "text-slate-500",
    label: null,
  },
};

/**
 * Compact legal / policy callout, styled to blend with the site.
 * Props: variant (emergency|hipaa|availability|noshow|info), label, testId, children
 */
export default function LegalNotice({ variant = "info", label, testId, children }) {
  const v = VARIANTS[variant] || VARIANTS.info;
  const Icon = v.icon;
  return (
    <div className={`rounded-xl border px-4 py-3.5 flex items-start gap-3 text-sm ${v.tone}`} data-testid={testId}>
      <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${v.iconTone}`} strokeWidth={2} />
      <div className="leading-relaxed">
        {(label || v.label) && (
          <div className="text-[11px] uppercase tracking-[0.18em] font-semibold opacity-80 mb-0.5">
            {label || v.label}
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  );
}

export function TermsLink({ children = "Terms & Conditions", className = "underline underline-offset-2 font-semibold hover:opacity-80" }) {
  return <Link to="/terms" className={className} target="_blank" rel="noopener">{children}</Link>;
}
